import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TermsEditor = ({ content, handledocument }) => {
  return (
    <div>
      <h2>Terms and Conditions</h2>
      <ReactQuill
        theme="snow"
        value={content}
        onChange={(e) => handledocument(e)}
        style={{ height: "260px" }}
      />
    </div>
  );
};

export default TermsEditor;
